var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyStarRemark = function SvgHappyStarRemark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#happyStarRemark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.61 13.747a1.083 1.083 0 1 0 0-2.166c-6.696-.152-9.75-3.25-9.75-9.75a1.083 1.083 0 1 0-2.167 0c0 6.554-3.131 9.652-9.75 9.75a1.083 1.083 0 1 0 0 2.166c6.564 0 9.652 3.099 9.75 9.75a1.083 1.083 0 1 0 2.166 0c.336-6.684 3.413-9.75 9.685-9.75zm-4.313-9.62h1.354v1.355a.812.812 0 1 0 1.625 0V4.127h1.355a.812.812 0 0 0 0-1.625h-1.355V1.148a.813.813 0 0 0-1.625 0v1.354h-1.354a.813.813 0 0 0 0 1.625m6.75 17.745h-1.355v-1.354a.813.813 0 0 0-1.625 0v1.354h-1.354a.812.812 0 1 0 0 1.625h1.354v1.355a.813.813 0 1 0 1.625 0v-1.355h1.355a.812.812 0 1 0 0-1.625"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "happyStarRemark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h26v26H0z"
  })))));
};
export default SvgHappyStarRemark;